import { ChangeEventHandler } from 'react';
import styles from './MeritoCheckbox.module.scss';

type Props = {
    name: string,
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
    error: any,
    touched: boolean,
    placeholder?: string
    value: boolean;
    containerStyles?: React.CSSProperties,
    size?: '' | 'md2'
    disabled?: boolean,
    showError?: boolean,
}

const MeritoCheckbox = ({ name, onChange: handleChange, error, touched, placeholder, value, containerStyles, size='', disabled = false, showError = true, ...restProps }: Props) => {

    // console.log('checkbox', value)
    return (
        <div className={styles.fieldContainer}>
            <input className={`${styles[size]}`} {...restProps} disabled={disabled} name={name} onChange={handleChange} type='checkbox' checked={value} />
            {error && touched && showError ? <span className={styles.errorMessage}>{error}</span> : null}
        </div>
    );
}

export default MeritoCheckbox;